import type { SingleEventByDate } from '../../types/RowType';

const generateRowId = (prefix: string, dates: SingleEventByDate): string => {
  if (!Object.keys(dates).length) {
    return prefix;
  }
  return Object.keys(dates).reduce((result, date) => {
    const { id } = dates[date];
    if (id) {
      result = `${result}_${id}`;
    }
    return result;
  }, prefix);
};

export default generateRowId;
